<div class="modal-container" data-testid="legal-name-fix-modal">
  <div class="modal-header">
    <h2 data-testid="legal-name-fix-title">{{ modalTitle | translate }}</h2>
    <button mat-icon-button (click)="close()" class="close-button" data-testid="legal-name-fix-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content">
    <!-- Loading state -->
    <div *ngIf="loading" class="loading-container" data-testid="legal-name-fix-loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'Loadingyourinformation' | translate }}</p>
    </div>

    <ng-container *ngIf="!loading">

      <!-- ===================================================================== -->
      <!-- NEW MODES: ACCEPT_CHANGES, FIX_CHANGES, VERIFY_CHANGES, REUPLOAD -->
      <!-- ===================================================================== -->

      <!-- ACCEPT_CHANGES MODE: Show diff, accept or reject -->
      <div *ngIf="isNewMode && modalMode === 'ACCEPT_CHANGES' && mismatchStep === 'main'" class="content" data-testid="legal-name-fix-accept-section">
        <p class="description">
          {{ 'Encontramos uma pequena diferença entre o nome que você informou e o nome no documento.' | translate }}
        </p>

        <div class="diff-section">
          <div class="info-card">
            <div class="field">
              <label>{{ 'Nome informado:' | translate }}</label>
              <div class="value" data-testid="legal-name-fix-accept-current-name">{{ currentName || ('Não informado' | translate) }}</div>
            </div>
          </div>

          <div class="arrow-indicator">
            <mat-icon>arrow_downward</mat-icon>
          </div>

          <div class="info-card highlight">
            <div class="field">
              <label>{{ 'Nome no documento:' | translate }}</label>
              <div class="value large" data-testid="legal-name-fix-accept-document-name">{{ veriffName || ('Não encontrado' | translate) }}</div>
            </div>
          </div>
        </div>

        <p class="question-text">
          <strong>{{ 'O nome no documento está correto?' | translate }}</strong>
        </p>

        <div class="actions space-between">
          <button class="def-button outline" (click)="rejectChanges()" [disabled]="saving" data-testid="legal-name-fix-reupload">
            {{ 'Não, quero enviar outro documento' | translate }}
          </button>
          <button class="def-button black" (click)="acceptChanges()" [disabled]="saving" data-testid="legal-name-fix-accept">
            <mat-spinner *ngIf="saving" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
            {{ saving ? ('Salvando' | translate) : ('Sim, usar este nome' | translate) }}
          </button>
        </div>
      </div>

      <!-- FIX_CHANGES MODE: Blind input to type name -->
      <div *ngIf="isNewMode && modalMode === 'FIX_CHANGES' && mismatchStep === 'main'" class="content" data-testid="legal-name-fix-fix-section">
        <!-- Description for AND flow (FIX + REUPLOAD) -->
        <ng-container *ngIf="data.actionLogic === 'AND'">
          <p class="description">
            {{ 'Os nomes informados são muito diferentes. Para continuar, informe seu nome correto e envie um novo documento.' | translate }}
          </p>
          <p class="instruction-text">
            {{ 'Digite seu nome completo correto:' | translate }}
          </p>
        </ng-container>

        <!-- Description for normal FIX flow -->
        <ng-container *ngIf="data.actionLogic !== 'AND'">
          <p class="description">
            {{ 'Para garantir a segurança da sua conta, precisamos que você confirme seu nome conforme aparece no documento.' | translate }}
          </p>
          <p class="instruction-text">
            {{ 'Digite seu nome completo exatamente como aparece no documento:' | translate }}
          </p>
        </ng-container>

        <div class="input-section">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'Nome completo' | translate }}</mat-label>
            <input
              matInput
              [ngModel]="fixedName"
              (ngModelChange)="onFixedNameChange($event)"
              placeholder="Ex: MARIA SOUZA DA SILVA"
              autocomplete="off"
              data-testid="legal-name-fix-name-input"
            />
          </mat-form-field>

          <div *ngIf="verifyError" class="error-message" data-testid="legal-name-fix-fix-error">
            <mat-icon>error</mat-icon>
            {{ verifyError }}
          </div>

          <div *ngIf="nameVerified && data.actionLogic !== 'AND'" class="success-message" data-testid="legal-name-fix-fix-success">
            <mat-icon>check_circle</mat-icon>
            {{ 'Nome verificado com sucesso!' | translate }}
          </div>
        </div>

        <div class="actions space-between">
          <button class="def-button outline" (click)="goToReuploadFromFix()" [disabled]="verifying || saving" *ngIf="data.actionLogic !== 'AND'" data-testid="legal-name-fix-fix-reupload">
            {{ 'Enviar outro documento' | translate }}
          </button>
          <button class="def-button black" (click)="verifyFixedName()" [disabled]="!canVerifyFix" data-testid="legal-name-fix-fix-verify">
            <mat-spinner *ngIf="verifying || saving" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
            <!-- AND flow: Just "Continuar" since there's no verification -->
            <ng-container *ngIf="data.actionLogic === 'AND'">
              {{ (verifying || saving) ? ('Salvando' | translate) : ('Continuar' | translate) }}
            </ng-container>
            <!-- Normal flow: "Verificar nome" -->
            <ng-container *ngIf="data.actionLogic !== 'AND'">
              {{ verifying ? ('Verificando' | translate) : ('Verificar nome' | translate) }}
            </ng-container>
          </button>
        </div>
      </div>

      <!-- FIX_CHANGES MODE: Blind input step (when coming from VERIFY_CHANGES option C) -->
      <div *ngIf="isNewMode && mismatchStep === 'fix_input'" class="content" data-testid="legal-name-fix-fixinput-section">
        <p class="description">
          {{ 'Por favor, digite seu nome completo correto:' | translate }}
        </p>

        <div class="input-section">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'Nome completo' | translate }}</mat-label>
            <input
              matInput
              [ngModel]="fixedName"
              (ngModelChange)="onFixedNameChange($event)"
              placeholder="Ex: MARIA SOUZA DA SILVA"
              autocomplete="off"
              data-testid="legal-name-fix-fixinput-name-input"
            />
          </mat-form-field>

          <div *ngIf="verifyError" class="error-message" data-testid="legal-name-fix-fixinput-error">
            <mat-icon>error</mat-icon>
            {{ verifyError }}
          </div>
        </div>

        <div class="actions" [class.center]="fromVerifyOptionC" [class.space-between]="!fromVerifyOptionC">
          <button class="def-button outline" (click)="goToReuploadFromFix()" [disabled]="verifying || saving" *ngIf="!fromVerifyOptionC" data-testid="legal-name-fix-fixinput-reupload">
            {{ 'Enviar outro documento' | translate }}
          </button>
          <button class="def-button black" (click)="verifyFixedName()" [disabled]="!canVerifyFix" data-testid="legal-name-fix-fixinput-verify">
            <mat-spinner *ngIf="verifying" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
            {{ verifying ? ('Verificando' | translate) : ('Verificar nome' | translate) }}
          </button>
        </div>
      </div>

      <!-- VERIFY_CHANGES MODE: Choose which name is correct -->
      <div *ngIf="isNewMode && modalMode === 'VERIFY_CHANGES' && mismatchStep === 'main'" class="content" data-testid="legal-name-fix-verify-section">
        <p class="description">
          {{ 'Encontramos uma diferença entre os nomes. Por favor, selecione qual nome está correto:' | translate }}
        </p>

        <div class="options-section">
          <button
            class="option-card"
            [class.selected]="verifyChoice === 'option_a'"
            (click)="selectVerifyOption('option_a')"
            [disabled]="saving"
            data-testid="legal-name-fix-verify-option-a"
          >
            <span class="option-label">{{ 'Opção A' | translate }}</span>
            <span class="option-value" data-testid="legal-name-fix-verify-option-a-value">{{ optionA }}</span>
          </button>

          <button
            class="option-card"
            [class.selected]="verifyChoice === 'option_b'"
            (click)="selectVerifyOption('option_b')"
            [disabled]="saving"
            data-testid="legal-name-fix-verify-option-b"
          >
            <span class="option-label">{{ 'Opção B' | translate }}</span>
            <span class="option-value" data-testid="legal-name-fix-verify-option-b-value">{{ optionB }}</span>
          </button>

          <button
            class="option-card secondary"
            [class.selected]="verifyChoice === 'option_c'"
            (click)="selectVerifyOption('option_c')"
            [disabled]="saving"
            data-testid="legal-name-fix-verify-option-c"
          >
            <span class="option-value">{{ 'Nenhum dos dois está correto' | translate }}</span>
          </button>
        </div>

        <div *ngIf="error" class="error-message center" data-testid="legal-name-fix-verify-error">
          <mat-icon>error</mat-icon>
          {{ error }}
        </div>

        <div class="actions center">
          <button class="def-button black" (click)="confirmVerifyChoice()" [disabled]="!canConfirmVerify" data-testid="legal-name-fix-verify-confirm">
            <mat-spinner *ngIf="saving" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
            {{ saving ? ('Processando' | translate) : ('Confirmar escolha' | translate) }}
          </button>
        </div>
      </div>

      <!-- REUPLOAD MODE: Just reupload button -->
      <div *ngIf="isNewMode && modalMode === 'REUPLOAD' && mismatchStep === 'main'" class="content centered-text" data-testid="legal-name-fix-reupload-section">
        <!-- Default message for REUPLOAD -->
        <p class="description" *ngIf="!isVeriffReadingError">
          {{ 'Para prosseguir, você precisa enviar um novo documento de identificação.' | translate }}
        </p>

        <p class="instruction-text" *ngIf="!isVeriffReadingError">
          {{ 'Certifique-se de que o nome no documento esteja legível e corresponda aos seus dados cadastrais.' | translate }}
        </p>

        <!-- Special message for B2b/B3b (Veriff reading error) -->
        <p class="description" *ngIf="isVeriffReadingError">
          {{ 'REUPLOAD_VERIFF_READING_ERROR_DESCRIPTION' | translate }}
        </p>

        <p class="instruction-text" *ngIf="isVeriffReadingError">
          {{ 'REUPLOAD_VERIFF_READING_ERROR_INSTRUCTION' | translate }}
        </p>

        <div class="actions center">
          <button class="def-button black" (click)="confirmReupload()" data-testid="legal-name-fix-reupload-submit">
            {{ 'Enviar novo documento' | translate }}
          </button>
        </div>
      </div>

      <!-- REUPLOAD CONFIRM STEP (shared across modes) -->
      <div *ngIf="isNewMode && mismatchStep === 'reupload_confirm'" class="content centered-text" data-testid="legal-name-fix-reupload-confirm-section">
        <!-- Default message for REUPLOAD CONFIRM -->
        <p class="description" *ngIf="!isVeriffReadingError">
          {{ 'Você será redirecionado para enviar um novo documento de identificação.' | translate }}
        </p>

        <p class="instruction-text" *ngIf="!isVeriffReadingError">
          {{ 'Certifique-se de que o documento esteja em boas condições e que o nome esteja legível.' | translate }}
        </p>

        <!-- Special message for B2b/B3b (Veriff reading error) -->
        <p class="description" *ngIf="isVeriffReadingError">
          {{ 'REUPLOAD_VERIFF_READING_ERROR_DESCRIPTION' | translate }}
        </p>

        <p class="instruction-text" *ngIf="isVeriffReadingError">
          {{ 'REUPLOAD_VERIFF_READING_ERROR_INSTRUCTION' | translate }}
        </p>

        <div class="actions" [class.center]="fromVerifyOptionC || data.actionLogic === 'AND'" [class.space-between]="!fromVerifyOptionC && data.actionLogic !== 'AND'">
          <button class="def-button outline" (click)="backFromReupload()" *ngIf="!fromVerifyOptionC && data.actionLogic !== 'AND'" data-testid="legal-name-fix-reupload-confirm-back">
            {{ 'Voltar' | translate }}
          </button>
          <button class="def-button black" (click)="confirmReupload()" data-testid="legal-name-fix-reupload-confirm-submit">
            {{ 'Confirmar e enviar documento' | translate }}
          </button>
        </div>
      </div>

      <!-- ===================================================================== -->
      <!-- LEGACY MODE: Original 3 scenarios -->
      <!-- ===================================================================== -->

      <!-- SCENARIO 1: Name Mismatch Only (Legacy) -->
      <div *ngIf="!isNewMode && currentStep === 'confirm' && isNameMismatchOnly" class="content" data-testid="legal-name-fix-legacy-name-section">
        <p class="description">
          {{ 'The information you provided doesn\'t match the information we read from your document.' | translate }}
        </p>

        <p class="question-text">
          <strong>{{ 'This is the information we extracted from your document, is this correct?' | translate }}</strong>
        </p>

        <div class="info-card highlight">
          <div class="field">
            <label>{{ 'Full Legal Name:' | translate }}</label>
            <div class="value-row">
              <span class="value large" data-testid="legal-name-fix-legacy-document-name">{{ veriffName || ('Not set' | translate) }}</span>
              <span class="annotation error-text"><- {{ 'name on document' | translate }}</span>
            </div>
          </div>
        </div>

        <div class="actions space-between">
          <button class="def-button black" (click)="goToCorrectDocumentStep()" [disabled]="saving" data-testid="legal-name-fix-legacy-name-reject">
            {{ 'No, this is not my correct name' | translate }}
          </button>
          <button class="def-button black" (click)="amendData()" [disabled]="saving" data-testid="legal-name-fix-legacy-name-amend">
            <mat-spinner *ngIf="saving" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
            {{ saving ? ('Saving' | translate) : ('Yes, please amend what I typed in before' | translate) }}
          </button>
        </div>
      </div>

      <!-- SCENARIO 3: Other Data Correction (Legacy) -->
      <div *ngIf="!isNewMode && currentStep === 'confirm' && !isNameMismatchOnly" class="content compact" data-testid="legal-name-fix-legacy-data-section">
        <p class="description compact">
          {{ 'The information you provided doesn\'t match the information we read from your document.' | translate }}
        </p>

        <!-- Questionnaire Data -->
        <div class="section compact">
          <p class="section-title">{{ 'The information you provided is:' | translate }}</p>
          <div class="info-card relative compact">
            <div class="field">
              <label>{{ 'Full Legal Name:' | translate }}</label>
              <div class="value" data-testid="legal-name-fix-legacy-data-current-name">{{ currentName || ('Not set' | translate) }}</div>
            </div>
            <div class="field">
              <label>{{ 'Date of Birth:' | translate }}</label>
              <div class="value">{{ currentDateOfBirth || ('Not set' | translate) }}</div>
            </div>
            <div class="field">
              <label>CPF:</label>
              <div class="value">{{ formatCpfDisplay(currentCpf) || ('Not set' | translate) }}</div>
            </div>
          </div>
        </div>

        <!-- Document Data -->
        <div class="section compact">
          <p class="section-title">{{ 'The information we read from your document is:' | translate }}</p>
          <div class="info-card relative compact">
            <div class="field">
              <label>{{ 'Full Legal Name:' | translate }}</label>
              <div class="value" data-testid="legal-name-fix-legacy-data-document-name">{{ data.documentData?.legalName || veriffName || ('Not set' | translate) }}</div>
            </div>
            <div class="field">
              <label>{{ 'Date of Birth:' | translate }}</label>
              <div class="value">{{ data.documentData?.dateOfBirth ? formatDateStringToDisplay(data.documentData?.dateOfBirth || '') : ('Not set' | translate) }}</div>
            </div>
            <div class="field">
              <label>CPF:</label>
              <div class="value">{{ formatCpfDisplay(data.documentData?.idNumber || '') || ('Not set' | translate) }}</div>
            </div>
          </div>
        </div>

        <p class="question-text compact">
          {{ 'How would you like to proceed?' | translate }}
        </p>

        <div class="actions space-between">
          <button class="def-button black" (click)="goToCorrectDocumentStep()" [disabled]="saving" data-testid="legal-name-fix-legacy-data-reupload">
            {{ 'Submit a different document' | translate }}
          </button>
          <button class="def-button black" (click)="amendData()" [disabled]="saving" data-testid="legal-name-fix-legacy-data-amend">
            <mat-spinner *ngIf="saving" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
            {{ saving ? ('Saving' | translate) : ('Please amend what I typed in before' | translate) }}
          </button>
        </div>
      </div>

      <!-- SCENARIO 2: Correcting Document (Legacy) -->
      <div *ngIf="!isNewMode && currentStep === 'correct-document'" class="content centered-text" data-testid="legal-name-fix-legacy-correct-section">
        <p class="description">
          {{ 'For security reasons, our process requires that you provide a document with the name matching the information you previously provided. We will now take you back to the document selection screen where you will be able to select a different document with your current name.' | translate }}
        </p>

        <div class="actions center">
          <button class="def-button black" (click)="selectNewDocument()" data-testid="legal-name-fix-legacy-select-document">
            {{ 'Select new document' | translate }}
          </button>
        </div>
      </div>

    </ng-container>
  </div>
</div>
